import React from 'react';
import App from '../App/App';
import {AssetServicesProvider} from '../Context/AssetServices/AssetServicesContext';
import {DragAndDropProvider} from '../Context/DragAndDrop/DragAndDropContext';
import {ObserverProvider} from '../Context/Observer/ObserverContext';
import {AssetUploadProvider} from '../Context/Upload/UploadContext';
import ForceLogin from '../ForceLogin/ForceLogin';
import {buildProvidersTree} from '../Providers';
import {KeyboardCommandProvider} from '../Context/KeyboardCommandsContext';

const AppView = () => {
  const AppProviderTree = buildProvidersTree([
    [AssetUploadProvider, {}],
    [AssetServicesProvider, {}],
    [DragAndDropProvider, {}],
    [ObserverProvider, {}],
    [KeyboardCommandProvider, {}],
  ]);

  return (
    <AppProviderTree>
      <ForceLogin>
        <App />
      </ForceLogin>
    </AppProviderTree>
  );
};

export default AppView;
